import { styled } from '@mui/material';
import { up } from '../../../theme';

export const classes = {
  root: 'root',
  logo: 'logo',
  image: 'image',
  text: 'text',
  button: 'button',
};

export const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.logo}`]: {
    marginTop: '150px',
    height: '40px',
    width: '150px',
  },
  [`& .${classes.image}`]: {
    marginTop: '27px',
    [up('xs')]: {
      height: '100px',
      width: '400px',
    },
    [up('sm')]: {
      height: '100px',
      width: '450px',
    },
    [up('md')]: {
      height: '100px',
      width: '600px',
    },
    [up('lg')]: {
      height: '120px',
      width: '650px',
    },
    [up('xl')]: {
      height: '120px',
      width: '700px',
    },
    [up('xxl')]: {
      height: '229px',
      width: '900px',
    },
  },
  [`& .${classes.button}`]: {
    [up('xs')]: {
      width: '100px',
      height: '14px',
      margin: '30px',
    },
    [up('sm')]: {
      width: '100px',
      height: '25px',
      margin: '30px',
    },
    [up('md')]: {
      width: '120px',
      height: '30px',
      margin: '27px',
    },
    [up('lg')]: {
      width: '130px',
      height: '40px',
      margin: '22px',
    },
    [up('xl')]: {
      width: '140px',
      height: '40px',
      margin: '50px',
    },
    [up('xxl')]: {
      width: '165px',
      height: '50px',
      margin: '50px',
    },
  },
}));
